export interface AggregatorValidationKeyArguments {
  approvalId: string;
}

/**
 * Hierarchical query-key factory for the Internal-tab Aggregator Validation
 * read (OR-24019). The shape mirrors `applicationStatusKeys` since the
 * endpoint returns a single object per deal, not a list: invalidating `all`
 * flushes every aggregator-validation query, `details()` flushes all reads,
 * and `detail({ approvalId })` flushes a single deal's validation. Never
 * write a literal key array outside this module — the factory IS the schema.
 */
export const aggregatorValidationKeys = {
  all: ["aggregatorValidation"] as const,
  details: () => [...aggregatorValidationKeys.all, "detail"] as const,
  detail: (arguments_: AggregatorValidationKeyArguments) =>
    [...aggregatorValidationKeys.details(), arguments_] as const,
};
